import {
    SET_GPS_STOPPED,
    SET_POSITION,
    GEOLOCALISATION_IN_PROGRESS,
} from './gpsConstants';
import { setValue } from '../../lib/immutable_wrapper'

const gpsInitialState = {
    gpsStopped: false,
    gpsPosition: {
        lat: 0,
        lon: 0,
    },
    geolocalisationInProgress: false,
};

export function gpsInformations(state = gpsInitialState, action) {
    switch (action.type) {
        case SET_GPS_STOPPED:
            return setValue(state, ['gpsStopped'], action.gpsStopped);
        case SET_POSITION:
            return setValue(state, ['gpsPosition'], action.position);
        case GEOLOCALISATION_IN_PROGRESS:
            return setValue(state, ['geolocalisationInProgress'], action.value);
        default:
            return state;
    }
}
